export default __webpack_public_path__ + "static/media/logo_gouv_qc.82d4b470.png";